/**
 * StageEditorRow — one editable stage row (rename, Sensitive/Terminal flags,
 * up/down reorder, delete) in the pipeline Stage editor (SE-5488).
 * @module features/player-kanban/components/molecules/StageEditorRow
 */

export { default } from "./StageEditorRowContainer";
export type { StageEditorRowContainerProps } from "./StageEditorRowContainer";
export type { StageEditorRowViewProps } from "./StageEditorRowView";
